import React from 'react';
import SidebarComponent from '../components/SidebarComponent';
import EditShopPageSliderComponent from '../components/EditShopPageSliderComponent';
import HeaderComponent from '../components/HeaderComponent';

class EditShopPageSliderPage extends React.Component {
    render() {
        return (
            <div className="wrapper">
                <SidebarComponent location={this.props.location}/>
                <HeaderComponent/>
                <EditShopPageSliderComponent id={this.props.match.params.id}/>
            </div>
        );
    }
}

export default EditShopPageSliderPage;